export default {
  getVaccines: (state) => state.vaccines,
  getVaccineList: (state) => state.vaccineList,
  getAgencyDeployments: (state) => state.agencyDeployments,
  getAgentDeployments: (state) => state.agentDeployments,
  getAllOses: (state) => state.allOses,
  getAllTypes: (state) => state.allTypes,
  getAllCategories: (state) => state.allCategories,
  getEditingVaccine: (state) => state.editingVaccine,
  getDqlFields: (state) => state.dqlFields,
  isLoading: (state) => state.loading,
};
